import { render, staticRenderFns } from "./BlogRead.vue?vue&type=template&id=10280626&scoped=true&"
import script from "./BlogRead.vue?vue&type=script&lang=js&"
export * from "./BlogRead.vue?vue&type=script&lang=js&"
import style0 from "./BlogRead.vue?vue&type=style&index=0&id=10280626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10280626",
  null
  
)

export default component.exports